const SESSION_KEY = 'telemetry_erp_session';

export interface AuthUser {
  id?: number;
  email: string;
  name: string;
  role?: string;
}

export function getSession(): AuthUser | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.email === 'string') {
      return parsed as AuthUser;
    }
    return null;
  } catch {
    return null;
  }
}

export function setSession(user: AuthUser): void {
  localStorage.setItem(SESSION_KEY, JSON.stringify(user));
}

export function logout(): void {
  localStorage.removeItem(SESSION_KEY);
}
